import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: true,
  filterPayload: { fields: [], conditions: [] },
}

const trafficDataSlice = createSlice({
  name: 'trafficData',
  initialState,
  reducers: {
    setFilterPayload: (state, action) => {
      state.filterPayload = action.payload
    },
    isLoading: (state, action) => {
      state.isLoading = action.payload
    },
  },
})

export const { isLoading, setFilterPayload } = trafficDataSlice.actions
export default trafficDataSlice.reducer
